import request, { METHODS } from "src/utils/api-base";

const tenantSignupRequestApis = {
  list: (params: { page: number; limit: number; status?: string; search?: string }) =>
    request({
      route: "/admin/signup-requests/list",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    }),
  getById: (id: string) =>
    request({
      route: `/admin/signup-requests/${id}`,
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    }),
  approve: (id: string) =>
    request({
      route: `/admin/signup-requests/${id}/approve`,
      method: METHODS.POST,
      auth: true,
      isAdminAuth: true,
    }),
  reject: (id: string) =>
    request({
      route: `/admin/signup-requests/${id}/reject`,
      method: METHODS.POST,
      auth: true,
      isAdminAuth: true,
    }),
  delete: (id: string) =>
    request({
      route: `/admin/signup-requests/${id}`,
      method: METHODS.DELETE,
      auth: true,
      isAdminAuth: true,
    }),
};

export default tenantSignupRequestApis;
